// extracted by mini-css-extract-plugin
module.exports = {"theme":"#304156","inputColor":"#2b3a4d"};